/**
 * Act 6 — final reveal scenario. Single screen (6.1). Extracted from
 * SceneRouter as part of M1.
 */

import type { ReactElement } from "react";
import type { Act6Screen } from "@/lib/scenes/screens";
import type { SceneRenderContext } from "@/lib/scenes/act4";
import { FinalReveal } from "@/components/scenes/act6/FinalReveal";

export const ACT6_RENDERERS: Record<Act6Screen, (ctx: SceneRenderContext) => ReactElement> = {
  "6.1": ({ ev, graph }) => <FinalReveal ev={ev} graph={graph} />,
};
